import {createReducer, on} from '@ngrx/store';
import * as AppActions from './app.actions';
import {User} from '@capacitor-firebase/authentication';

export interface AppState {
    user: User;
    connected: boolean;
    notificationToken: string;
    loading: boolean;
    error: any;
}

const initialState: AppState = {
    user: undefined,
    connected: false,
    notificationToken: undefined,
    loading: false,
    error: null,
};

const _appReducer = createReducer(
    initialState,
    on(AppActions.userLoad, (state, {user}) => ({...state, user: user})),
    on(AppActions.websocketOpened, (state) => ({...state, connected: true})),
    on(AppActions.websocketClosed, (state) => ({...state, connected: false})),
    on(AppActions.notificationToken, (state, {token}) => ({...state, notificationToken: token})),
);

export function appReducer(state, action) {
    return _appReducer(state, action);
}
